import React from 'react'
import styled from 'styled-components'
import Text from 'core-system/Text/Text'
import { WorksiteHoverDetails } from './worksiteDistribution'

const Card = styled.div`
  min-width: 10rem;
  max-width: 16rem;
`

const Programs = styled(Text)`
  display: block;
  margin-top: 0.25rem;
  color: ${(props) => props.theme.palette.text.secondary};
`

interface WorksiteDistributionHoverProps {
  details: WorksiteHoverDetails
}

const WorksiteDistributionHover = ({
  details,
}: WorksiteDistributionHoverProps) => {
  return (
    <Card>
      <Text variant='action4'>{details.name}</Text>
      <Text variant='body2'>{details.people}</Text>
      <Text variant='body2'>{details.enrolled}</Text>
      <Programs variant='caption'>{details.programs}</Programs>
    </Card>
  )
}

export default React.memo(WorksiteDistributionHover)
